<template>
  <div class="buyProduct-content">
    <div class="buyProduct">
      <div class="basic-information-title">拥有产品</div>
      <div>
        <img
          :src="require('@/assets/img/scan_code.png')"
          style="margin-right: 0.2rem"
          class="newlyAddImg"
          alt
          @click="scanQR()"
          srcset
          v-if="showCC == true && hasPRCreated"
        />
        <img
          :src="require('@/assets/img/newlyAdd.png')"
          class="newlyAddImg"
          alt
          @click="redact(1)"
          srcset
          v-if="showCC == true && hasPRCreated"
        />
      </div>
    </div>
    <van-tabs sticky swipeable title-active-color="red" v-model="tabActive">
      <van-tab
        v-for="(tabItem, index) in tab"
        :title="tabItem.name"
        v-bind:key="tabItem.index"
      >
        <div class="product-list" v-if="list.length > 0">
          <div
            v-for="(item, index) in list"
            v-if="
              item.products1stType == tabItem.key ||
              (tabItem.key == '运动光学' && item.products1stType == '配件')
            "
            v-bind:key="index"
          >
            <div class="flex product-list-header">
              <div class="flex center">
                <img
                  class="camera"
                  :src="require('@/assets/img/camera.png')"
                  alt
                />
                <div class="product-name">
                  产品大类-{{ item.products1stType || "" }}
                </div>
              </div>
              <img
                :src="require('@/assets/img/redact.png')"
                class="redactImg"
                alt
                @click="redact(2, item.purchaseRecordId)"
                srcset
                v-if="showCC == true && hasPRModified"
              />
            </div>
            <div class="product-list-content">
              <!-- <img
                      :src="require('@/assets/img/redact.png')"
                      class="redactImg redactImgFlexed"
                      alt
                      @click="redact(2)"
                      srcset
                    > -->
              <div
                class="basic-information-flex"
                v-bind:class="item.edit == true ? 'active' : 'activeno'"
              >
                <div class="list-status">
                  <p v-if="item.activatedState != 1">未激活</p>

                  <p v-if="item.activatedState == 1">已激活</p>
                  <!--              <a v-if="item.activatedState==1" @click="showImage(item.eCWarrantycardurl)">查看保卡</a>-->
                </div>
                <ul class="basic-information-lists">
                  <!--<li>
                          <div class="basic-information-lists-item">日期</div>
                          <div class="basic-information-lists-text">{{item.createdTime||''}}</div>
                        </li>-->
                  <li>
                    <div class="basic-information-lists-item">购买日期</div>
                    <div class="basic-information-lists-text">
                      {{ item.buyDate }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">门店</div>
                    <div class="basic-information-lists-text">
                      {{ item.deptName || "" }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">中文名称</div>
                    <div class="basic-information-lists-text">
                      {{ item.productNameCH || "" }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">销售金额</div>
                    <div class="basic-information-lists-text">
                      {{ $numeral(item.amountAftTax).format("0,0.00") }}
                    </div>
                  </li>
                  <!--              <li>-->
                  <!--                <div class="basic-information-lists-item">未税金额</div>-->
                  <!--                <div class="basic-information-lists-text">{{$numeral(item.amount).format('0,0.00')}}</div>-->
                  <!--              </li>-->

                  <li>
                    <div class="basic-information-lists-item">产品编号</div>
                    <div class="basic-information-lists-text">
                      {{ item.code }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">产品大类</div>
                    <div class="basic-information-lists-text">
                      {{ item.products1stType }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">产品分类</div>
                    <div class="basic-information-lists-text">
                      {{ item.products2ndType }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">产品英文</div>
                    <div class="basic-information-lists-text">
                      {{ item.productNameEN }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">序列号</div>
                    <div class="basic-information-lists-text">
                      {{ item.serial }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">是否易手机</div>
                    <div class="basic-information-lists-text">
                      <span v-if="item.U_SecondProduct === '1'">是</span>
                      <span v-else>否</span>
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">未激活原因</div>
                    <div class="basic-information-lists-text">
                      {{ item.reason }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">保修期</div>
                    <div class="basic-information-lists-text">
                      {{ item.defectsLiabilityPeriod || "" }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">延保服务期</div>
                    <div class="basic-information-lists-text">
                      {{ item.extensionServicePeriod }}
                    </div>
                  </li>
                  <li>
                    <div class="basic-information-lists-item">保修到期日</div>
                    <div class="basic-information-lists-text">
                      {{ item.warrantyExpirationDate }}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 收起 -->
            <div class="flex packUp center" @click="packUp(index)">
              <img
                :src="require('@/assets/img/upArrow1.png')"
                v-if="item.edit == true"
                class="arrow"
                alt
                srcset
              />
              <img
                :src="require('@/assets/img/dowmArrow.png')"
                v-if="item.edit == false"
                class="arrow"
                alt
                srcset
              />
              {{ item.edit == true ? "收起详情" : "展开详情" }}
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 弹框 -->
    <div class="product-model">
      <van-popup
        v-model="productShow"
        :overlay="true"
        :close-on-click-overlay="false"
      >
        <div class="model-height">
          <div class="product-title">{{ nameTitle }}购买产品</div>

          <div class="basic-models-list">
            <!-- 购买日期 -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title">购买日期</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="timeSelections()">
                {{ pullList[12]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">产品货号</div>
              <input
                type="text"
                v-model="pullList[0]['name']"
                oninput="if(value.length>50)value=value.slice(0,50)"
                :disabled="pullList[0]['editTallage'] != null"
                @blur="
                  pullList[0]['name'] != ''
                    ? productCode(pullList[0]['name'])
                    : ''
                "
                placeholder="请输入产品货号"
                @keyup.enter="productCode(pullList[0]['name'])"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">序列号</div>
              <input
                type="text"
                v-model="pullList[1]['name']"
                :placeholder="editS == true ? '请输入序号' : ''"
                :disabled="pullList[1]['editTallage'] != null"
                oninput="if(value.length>50)value=value.slice(0,50)"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">产品大类</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div
                class="selectUp"
                @click="
                  pullList[2]['editTallage'] != null ? '' : downSelections(2)
                "
              >
                {{ pullList[2]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">产品分类</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div
                class="selectUp"
                @click="
                  pullList[3]['editTallage'] != null ? '' : downSelections(3)
                "
              >
                {{ pullList[3]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">产品中文名</div>
              <input
                type="text"
                v-model="pullList[4]['name']"
                oninput="if(value.length>50)value=value.slice(0,50)"
                :disabled="pullList[4]['editTallage'] != null"
                placeholder="请输入产品中文名"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">产品英文名</div>
              <input
                type="text"
                v-model="pullList[5]['name']"
                oninput="if(value.length>50)value=value.slice(0,50)"
                :disabled="pullList[5]['editTallage'] != null"
                placeholder="请输入产品英文名"
              />
            </div>

            <!-- v-show="pullList[13]['show']!=null&&pullList[13]['show']" -->
            <div class="basic-models-list-item">
              <div class="models-list-item-title">建议零售价</div>
              <input
                type="number"
                v-model="pullList[13]['name']"
                disabled="disabled"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">销售金额</div>
              <input
                type="number"
                v-model="pullList[6]['name']"
                oninput="if(value.length>50)value=value.slice(0,50)"
                @blur="ratesCount"
                placeholder="请输入销售金额"
              />
            </div>
            <div class="basic-models-list-item">
              <div class="models-list-item-title">是否易手机</div>
              <div class="second-product">
                <van-switch
                  v-model="pullList[16]['val']"
                  active-color="#ff4040"
                />
              </div>
            </div>
            <div class="basic-models-list-item" v-show="false">
              <div class="models-list-item-title">未税金额</div>
              <input
                type="number"
                v-model="pullList[7]['name']"
                :disabled="editTallage"
                oninput="if(value.length>50)value=value.slice(0,50)"
                placeholder="请输入未税金额"
              />
            </div>

            <div class="basic-models-list-item" style="height: 1.5rem">
              <div class="models-list-item-title">上传购买凭证</div>
              <div class="van-uploader__preview">
                <div
                  class="van-image van-uploader__preview-image"
                  @click="selectImage()"
                >
                  <img
                    :src="uploadCertificate"
                    class="van-image__img"
                    style="object-fit: cover"
                  />
                </div>
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">优惠劵</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(8)">
                {{ pullList[8]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">未激活原因</div>
              <input
                type="text"
                v-model="pullList[14]['name']"
                disabled="disabled"
                placeholder="暂无"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">劵号</div>
              <input
                type="text"
                v-model="pullList[9]['name']"
                maxlength="50"
                placeholder="请输入劵号"
              />
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">购买门店</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(10)">
                {{ pullList[10]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">销售顾问</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div
                class="selectUp"
                @click="pullList[10]['val'] ? downSelections(11) : ''"
              >
                {{ pullList[11]["name"] || "请选择" }}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 确定取消 -->
        <div class="confirm-cancel">
          <div class="button-flex-color flex-border-button">
            <div class="button-flex-item" @click="cancelProduct">取消</div>
          </div>
          <div class="button-flex-color">
            <div class="button-flex-item button-active" @click="confirmProduct">
              确定
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <!-- 下拉筛选 -->
    <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title
        :columns="downSelection"
        @cancel="onCancelCode"
        @confirm="onConfirmCode"
        :value-key="'name' || 'deptName'"
        class="van-picker-li"
      />
    </van-popup>
    <!-- 时间筛选 -->
    <van-popup
      v-model="timeShow"
      position="bottom"
      :overlay="true"
      style="width: 100%"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        :max-date="maxDate"
        :min-date="minDate"
      />
    </van-popup>

    <div class="product-model-min">
      <van-popup v-model="submitShow">
        <div class="model-height">
          <div class="product-title">激活保卡信息上传成功</div>
        </div>

        <!-- 确定取消 -->
        <div class="confirm-cancel">
          <div class="button-flex-color">
            <div class="button-flex-item button-active" @click="submitShowf">
              确定
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>


<script>
import { Dialog } from "vant";
export default {
  name: "",
  data() {
    return {
      list: [],
      taginfo: {},
      tabActive: 0,
      tab: [
        {
          name: "徕卡相机",
          select: true,
          key: "徕卡相机",
        },
        {
          name: "徕卡镜头",
          select: true,
          key: "徕卡镜头",
        },
        {
          name: "运动光学及配件",
          select: true,
          key: "运动光学",
        },
      ],
      nameTitle: "修改",
      pullList: [
        {
          name: "",
          val: "",
        }, //产品货号 1
        {
          name: "",
          val: "",
        }, //序列号 2
        {
          name: "",
          val: "",
        }, //产品大类 3
        {
          name: "",
          val: "",
        }, //产品分类 4
        {
          name: "",
          val: "",
        }, //产品中文名  5
        {
          name: "",
          val: "",
        }, //产品英文名  6
        {
          name: "",
          val: "",
        }, //零售价  7
        {
          name: "",
          val: "",
        }, //未税金额 8
        {
          name: "",
          val: "",
        }, //优惠卷  9
        {
          name: "",
          val: "",
        }, //卷号 10
        {
          name: "",
          val: "",
        }, //购买门店 11
        {
          name: "",
          val: "",
        }, //销售顾问 12
        {
          name: this.$time(
            new Date(
              this.$D.getFullYear(),
              this.$D.getMonth(),
              this.$D.getDate()
            )
          ),
          val: this.$time(
            new Date(
              this.$D.getFullYear(),
              this.$D.getMonth(),
              this.$D.getDate()
            )
          ),
        }, //购买日期 13
        {
          name: "",
          val: "",
        }, //建议零售价 14
        {
          name: "",
          val: "",
        }, //未激活原因 15
        {
          name: "",
          val: "",
        },
        {
          name: "",
          val: false,
        }, // 是否易手机
      ],
      // 字典表查询code
      codeList: ["Products1stType", "Products2ndType"],
      currency: null, //国家
      showDownSelection: false, // 下拉菜单展示
      timeShow: false, // 下拉时间展示
      currentDate: new Date(), // 时间
      minDate: new Date(new Date()), // 最小时间
      downSelection: ["1", "2"], // 下拉列表
      productShow: false, // 新增 编辑 展示
      Products1stType: [], // 产品大类
      Products2ndType: [], // 产品分类
      CouponType: [], // 优惠卷类型
      Dealer: [], // 门店     经销商列表
      Sales: [], // 销售顾问  销售用户
      editSerial: false, //是否有需要
      editTallage: true, //未税金额 不可修改
      showCodeSelection: 0, //当前点击索引
      isEnglish: this.$validator().isEnglish,
      isCumberNo: this.$validator().isCumberNo,
      editS: true, //判断是否可以输入序列号  true可以 false  不可以
      rates: this.$wxuserUtil.getDeptTaxRate() / 100, //税率
      custId: "", //客户ID
      purchaseRecordId: "", //客户购买产品ID
      showCC: true, //权限
      timeShow: false, //时间筛选
      currentDate: new Date(
        this.$D.getFullYear(),
        this.$D.getMonth(),
        this.$D.getDate()
      ), // 时间
      minDate: new Date(
        this.$D.getFullYear() - 10,
        this.$D.getMonth(),
        this.$D.getDate()
      ), // 最小时间
      maxDate: new Date(
        this.$D.getFullYear(),
        this.$D.getMonth(),
        this.$D.getDate()
      ),
      hasPRCreated: true, //购买产品创建权限
      hasPRModified: true, //购买产品修改权限
      qrcode: null, //产品二维码
      submitShow: false, //二维码提交后显示
      latitude: "", //纬度
      longitude: "", //经度
      uploadCertificate: require("@/assets/img/uploadPho.png"), //
      http: this.$http,
      deptType: null,
    };
  },
  methods: {
    submitShowf() {
      this.cancelProduct();
    },
    selectImage() {
      var that = this;
      var layerui = layer;
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
        defaultCameraMode: "normal", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。从3.0.26版本开始支持front和batch_front两种值，其中front表示默认为前置摄像头单拍模式，batch_front表示默认为前置摄像头连拍模式。（注：用户进入拍照界面仍然可自由切换两种模式）
        isSaveToAlbum: 1, //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
        success: function (res) {
          var localIds = res.localIds;
          let layerIndex = layerui.open({
            type: 2,
            shade: "background-color: rgba(0,0,0,.3)",
            content: "加载中",
          });
          that.$wxuserUtil.uploadImage(
            localIds,
            function (response) {
              if (response.success) {
                let data = response.data;
                that.uploadCertificate = that.http + data;
              }
              layerui.close(layerIndex);
            },
            function (err) {
              layerui.close(layerIndex);
              alert("图片上传异常");
            }
          );
        },
      });
    },
    showImage(url) {
      Dialog.alert({
        message: '<img height="100%" width="100%"   src="' + url + '" />',
      }).then(() => {
        // on close
      });
    },
    redact(ID, D_) {
      this.getLocation();
      if (ID == 1) {
        this.purchaseRecordId = "";
        this.nameTitle = "新增";
        this.pullList[10]["name"] = this.$wxuserUtil.getDeptName();
        this.pullList[10]["val"] = this.$wxuserUtil.getDeptId();
        this.pullList[11]["name"] = this.$wxuserUtil.getUserName();
        this.pullList[11]["val"] = this.$wxuserUtil.getUserId();
        this.getSaleslist(this.$wxuserUtil.getDeptId());
      } else {
        this.purchaseRecordId = D_;
        this.nameTitle = "修改";
        this.getDetailSoldProdCust();
      }
      this.productShow = true;
    },
    scanQR() {
      this.getLocation();
      this.purchaseRecordId = "";
      this.nameTitle = "新增";
      this.pullList[10]["name"] = this.$wxuserUtil.getDeptName();
      this.pullList[10]["val"] = this.$wxuserUtil.getDeptId();
      this.pullList[11]["name"] = this.$wxuserUtil.getUserName();
      this.pullList[11]["val"] = this.$wxuserUtil.getUserId();
      this.getSaleslist(this.$wxuserUtil.getDeptId());
      var that = this;

      var qrdatil = function (resultStr) {
        that.$api
          .getDetailSoldProdQrCode({
            salesId: that.$wxuserUtil.getUserId(),
            qrcode: resultStr,
          })
          .then((Response) => {
            console.log("扫码查询后的返回", Response);

            if (Response.success && Response.code == 1) {
              that.productShow = true;
              let $data = Response.data;
              let $PL = [];
              $PL = that.pullList;
              $PL[0]["name"] = $data.code || "";
              $PL[0]["val"] = $data.code || "";
              $PL[0]["editTallage"] = $PL[0]["val"] != "" ? true : null;
              $PL[1]["name"] = $data.serial || "";
              $PL[1]["val"] = $data.serial || "";
              $PL[1]["editTallage"] = $PL[1]["val"] != "" ? true : null;
              $PL[2]["name"] = $data.products1stType || "";
              $PL[2]["val"] = $data.products1stType || "";
              $PL[2]["editTallage"] = $PL[2]["val"] != "" ? true : null;
              $PL[3]["name"] = $data.products2ndType || "";
              $PL[3]["val"] = $data.products2ndType || "";
              $PL[3]["editTallage"] = $PL[3]["val"] != "" ? true : null;
              $PL[4]["name"] = $data.productNameCH || "";
              $PL[4]["val"] = $data.productNameCH || "";
              $PL[4]["editTallage"] = $PL[4]["val"] != "" ? true : null;
              $PL[5]["name"] = $data.productNameEN || "";
              $PL[5]["val"] = $data.productNameEN || "";
              $PL[5]["editTallage"] = $PL[5]["val"] != "" ? true : null;
              $PL[6]["name"] = $data.srp || "";
              $PL[6]["val"] = $data.srp || "";
              $PL[13]["name"] = $data.srp || "";
              $PL[13]["val"] = $data.srp || "";
              $PL[13]["show"] = true;
              that.currency = $data.currency;

              // $PL[7]['name'] = $data.amount;
              // $PL[7]['val'] = $data.amount;
              that.ratesCount();
              // $PL[12]['val'] = $data.buyDate;
              // $PL[12]['name'] = $data.buyDate;
              that.pullList = $PL;
              // this.ratesCount();
            } else {
              alert(Response.msg);
              that.qrcode = null;
            }
          });
      };

      // that.qrcode='1LC10301207982611525728901';
      // "1LC10301207982611525728901"   res.resultStr
      // qrdatil("1LC10301207982611525728901");
      //扫码正确的结果
      wx.scanQRCode({
        desc: "描产品包装二维码",
        needResult: 1, // 默认为0，扫描结果由企业微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是条形码（一维码），默认二者都有
        success: function (res) {
          // 回调
          if (res.resultStr) {
            that.qrcode = res.resultStr;
            qrdatil(res.resultStr);
          }
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("版本过低请升级");
          }
        },
      });
    },

    /**
     *  获取地理位置
     *
     */
    getLocation() {
      var that = this;
      // that.latitude = 28.17894; // 纬度，浮点数，范围为90 ~ -90
      // that.longitude = 112.9791;
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          that.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          that.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        },
        fail: function (res) {
          // alert("位置被拒绝")
          alert(res.errMsg);
        },
      });
    },
    /**
     *
     *  下拉菜单点击
     *  @param {index}   val
     *
     */
    downSelections(val) {
      this.showCodeSelection = val;
      switch (val) {
        case 2:
          this.downSelection = this.setCodeAlls(this.Products1stType);
          break;
        case 3:
          this.downSelection = this.setCodeAlls(this.Products2ndType);
          break;
        case 8:
          this.downSelection = this.setCodeAlls(this.CouponType);
          break;
        case 10:
          this.downSelection = this.setCodeAlls(this.Dealer);
          break;
        case 11:
          this.downSelection = this.Sales;
          break;
      }
      this.showDownSelection = true;
    },
    cancelProduct() {
      this.productShow = false;
      this.submitShow = false;
      let $PL = [];
      $PL = this.pullList;
      for (let i = 0; i < $PL.length; i++) {
        $PL[i]["name"] = "";
        $PL[i]["val"] = "";
        $PL[i]["editTallage"] = null;
        $PL[i]["show"] = null;
      }

      $PL[12]["name"] = this.$time(
        new Date(this.$D.getFullYear(), this.$D.getMonth(), this.$D.getDate())
      );
      $PL[12]["val"] = this.$time(
        new Date(this.$D.getFullYear(), this.$D.getMonth(), this.$D.getDate())
      );
      $PL[16]["val"] = false;
      this.pullList = $PL;
      this.qrcode = null;
      this.latitude = "";
      this.longitude = "";
      this.uploadCertificate = require("@/assets/img/uploadPho.png");
    },
    // 购买产品新增 编辑
    confirmProduct() {
      let $data = this.pullList;
      if ($data[0]["name"] == "") {
        this.$title("请输入产品货号");
        return;
      }
      // if(this.editS==true){
      //    if($data[1]['name']==''){
      //      this.$title("请输入产品序列号");
      //      return;
      //    }
      // }
      if ($data[2]["val"] == "") {
        this.$title("请选择产品大类");
        return;
      }
      if ($data[3]["val"] == "") {
        this.$title("请选择产品分类");
        return;
      }
      if ($data[4]["name"] == "") {
        this.$title("请输入产品中文名称");
        return;
      }

      if ($data[5]["name"] == "") {
        this.$title("请输入英文名称");
        return;
      }

      if (this.$validator().isChinese($data[5]["name"]) == true) {
        this.$title("请输入产品英文名称");
        return;
      }

      if ($data[6]["name"] == "") {
        this.$title("请输入零售价");
        return;
      }

      if ($data[7]["name"] == "") {
        this.$title("未税金额不能为空");
        return;
      }
      // if(this.isCumberNo($data[7]['name'])==false){
      //         this.$title("未税金额只能为数字");
      //         return;
      // }
      if ($data[10]["val"] == "") {
        this.$title("请选择购买门店");
        return;
      }
      if ($data[11]["name"] == "") {
        this.$title("请选择销售用户");
        return;
      }
      if (this.latitude == "" || this.longitude == "") {
        this.$title("获取位置失败，请退出后重试");
        return;
      }

      let data = {};
      data["salesId"] = this.$wxuserUtil.getUserId();
      data["custId"] = this.custId || this.$parent.$parent.custId;
      data["purchaseRecordId"] = this.purchaseRecordId
        ? this.purchaseRecordId
        : "";
      data["code"] = this.pullList[0]["name"];
      data["serial"] = this.pullList[1]["name"];
      data["products1stType"] = this.pullList[2]["val"];
      data["products2ndType"] = this.pullList[3]["val"];
      data["productNameCH"] = this.pullList[4]["name"];
      data["productNameEN"] = this.pullList[5]["name"];
      data["amountAftTax"] = this.pullList[6]["name"];
      data["amount"] = this.pullList[7]["name"];
      data["couponType"] = this.pullList[8]["val"];
      data["couponNo"] = this.pullList[9]["name"];
      data["deptId"] = this.pullList[10]["val"];
      data["userId"] = this.pullList[11]["val"];
      data["date"] = this.pullList[12]["name"];
      data["latitude"] = this.latitude;
      data["longitude"] = this.longitude;
      if (this.currency != null) {
        data["currency"] = this.currency;
      }
      if (this.qrcode != null) {
        data["qrcode"] = this.qrcode;
      }
      if (this.pullList[13]["name"] != "") {
        data["SRP"] = this.pullList[13]["name"];
      }
      if (this.uploadCertificate.indexOf(this.http) != -1) {
        data["salesTicketUrl"] = this.uploadCertificate.replace(this.http, "");
      }
      data["U_SecondProduct"] = this.pullList[16]["val"] ? 1 : 0;

      this.$loading();
      this.$api.saveSoldProdCusts(data).then((Response) => {
        if (Response.success) {
          if (this.purchaseRecordId) {
            this.$clear("修改成功");
            this.getCustListSoldProd(this.custId);
          } else {
            this.$clear("新增成功");
            this.getCustListSoldProd(this.custId);
            if (this.qrcode != null) {
              this.submitShow = true;
            }
          }
          if (this.qrcode == null) {
            this.productShow = false;
            this.cancelProduct();
          }
          this.$parent.$parent.getCustDetail(
            this.custId || this.$parent.$parent.custId
          );
        } else {
          this.$title(Response.msg);
          // this.productShow=false;
        }
      });
    },
    /**
     *
     *   添加全部
     *
     */
    setCodeAlls(data) {
      if (Array.isArray(data)) {
        return [
          {
            name: "请选择",
            value: "",
            val: "",
          },
        ].concat(data);
      } else {
        return [].concat(data);
      }
    },

    /**
     *
     * 字典查询
     *
     */
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        let tcode = this.codeList[i];
        this.$api
          .getQueryByTcode({
            tcode: tcode,
          })
          .then((Response) => {});
      }
    },
    /**
     *
     *  查询经销商
     *
     **/
    getDealerlist() {
      this.$api
        .getDealerlist({
          salesId: this.$wxuserUtil.getUserId(),
        })
        .then((Response) => {
          this.Dealer = this.changeList(Response.data, 1);
        });
    },
    /**
     *
     *   销售用户
     *
     **/
    getSaleslist(deptId) {
      this.$api
        .getSaleslist({
          salesId: this.$wxuserUtil.getUserId(),
          deptId: deptId,
        })
        .then((Response) => {
          this.Sales = this.changeList(Response.data, 2);
        });
    },
    /**
     *
     *
     *  根据产品货号查询 是否有序号
     *
     */
    productCode(val) {
      this.$api
        .getQueryExistSerial({
          salesId: this.$wxuserUtil.getUserId(),
          artNumber: val,
        })
        .then((Response) => {
          if (Response.success) {
            this.editS = Response.data;
            //  this.editS=true;
            if (this.editS == false) {
              this.pullList[1]["name"] = "";
            }
            if (Response.data == false) {
              this.serialCode();
            }
          } else {
            this.$title(Response.msg);
          }
        });

      this.getProdQueryPrice(val);
    },

    /**
     * 获取产品价格
     * @param {Object} code  货号
     */
    getProdQueryPrice(code) {
      this.$api
        .getProdQueryPrice({
          salesId: this.$wxuserUtil.getUserId(),
          code: code,
        })
        .then((Response) => {
          if (Response.success) {
            let $PL = this.pullList;
            let data = Response.data;
            if (Response.data) {
              $PL[2]["name"] = data.products1stType || "";
              $PL[2]["val"] = data.products1stType || "";
              $PL[2]["editTallage"] = $PL[2]["val"] != "" ? true : null;
              $PL[3]["name"] = data.products2ndType || "";
              $PL[3]["val"] = data.products2ndType || "";
              $PL[3]["editTallage"] = $PL[3]["val"] != "" ? true : null;
              $PL[4]["name"] = data.productNameCH || "";
              $PL[4]["val"] = data.productNameCH || "";
              $PL[4]["editTallage"] = $PL[4]["val"] != "" ? true : null;
              $PL[5]["name"] = data.productNameEN || "";
              $PL[5]["val"] = data.productNameEN || "";
              $PL[5]["editTallage"] = $PL[5]["val"] != "" ? true : null;
              $PL[13]["name"] = data.price || "";
              $PL[13]["val"] = data.price || "";
              $PL[13]["show"] = true;
            } else {
              $PL[13]["name"] = "";
              $PL[13]["val"] = "";
              $PL[13]["show"] = false;
            }
            this.ratesCount();
            this.pullList = $PL;
          }
        });
    },

    /**
     *
     *
     *  根据货号序号 查询产品详情数据
     *
     *
     */
    serialCode(val) {
      this.$api
        .getProdQueryDetail({
          salesId: this.$wxuserUtil.getUserId(),
          artNumber: this.pullList[0]["name"],
          serial: this.editS == true ? this.pullList[1]["name"] : "",
        })
        .then((Response) => {
          if (Response.success == true) {
            console.log("mmmmmmmmmmm", Response);
            if (Response.data) {
              console.log("货号查序号", Response.data);
              let $pullList = [];
              $pullList = this.pullList;
              $pullList[0]["name"] = Response.data.art_number || "";
              $pullList[0]["val"] = Response.data.art_number || "";
              $pullList[1]["name"] = Response.data.serial || "";
              $pullList[1]["val"] = Response.data.serial || "";
              $pullList[2]["name"] = Response.data.products1stType || "";
              $pullList[2]["val"] = Response.data.products1stType || "";
              $pullList[3]["name"] = Response.data.products2ndType || "";
              $pullList[3]["val"] = Response.data.products2ndType || "";
              $pullList[4]["name"] = Response.data.products3rdType || "";
              $pullList[4]["val"] = Response.data.products3rdType || "";
              $pullList[5]["name"] = Response.data.ProductNameEN || "";
              $pullList[5]["val"] = Response.data.ProductNameEN || "";
              $pullList[6]["name"] = Response.data.Amount || "";
              $pullList[6]["val"] = Response.data.Amount || "";
              $pullList[7]["name"] = "";
              $pullList[7]["val"] = "";
              this.pullList = $pullList;
              this.ratesCount();
            } else {
              let $pullList = [];
              $pullList = this.pullList;
              // $pullList[1]['name']='';
              // $pullList[1]['val']='';
              $pullList[2]["name"] = "";
              $pullList[2]["val"] = "";
              $pullList[3]["name"] = "";
              $pullList[3]["val"] = "";
              $pullList[4]["name"] = "";
              $pullList[4]["val"] = "";
              $pullList[5]["name"] = "";
              $pullList[5]["val"] = "";
              $pullList[6]["name"] = "";
              $pullList[6]["val"] = "";
              $pullList[7]["name"] = "";
              $pullList[7]["val"] = "";
              this.pullList = $pullList;
            }
          }
        });
    },
    changeList(DATA, ID) {
      if (Array.isArray(DATA)) {
        for (let i = 0; i < DATA.length; i++) {
          if (ID == 1) {
            DATA[i]["name"] = DATA[i]["deptName"];
            DATA[i]["value"] = DATA[i]["deptId"];
          } else {
            DATA[i]["name"] = DATA[i]["userName"];
            DATA[i]["value"] = DATA[i]["userId"];
          }
        }
        return DATA;
      }
    },
    /**
     *
     *
     *   下拉菜单 确认 取消
     *
     */
    onCancelCode(val) {
      this.showDownSelection = false;
    },
    onConfirmCode(val) {
      this.pullList[this.showCodeSelection]["name"] = val.name;
      this.pullList[this.showCodeSelection]["value"] = val.value;
      this.pullList[this.showCodeSelection]["val"] = val.value;
      if (this.showCodeSelection == 2) {
        this.getProdQuery2st();
      } else if (this.showCodeSelection == 10) {
        this.getSaleslist(val.value);
      } else if (this.showCodeSelection == 8) {
        //优惠券选择
        let couponPrefix = val.prefix || "";
        if (couponPrefix) {
          let couponNo = this.pullList[9]["name"];
          this.pullList[9]["name"] = couponPrefix;
        }
      }

      this.showDownSelection = false;
    },
    /**
     *
     *
     *   已购买产品列表
     *
     *
     */
    getCustListSoldProd(custId) {
      this.custId = custId;
      let that = this;
      this.$api
        .getCustListSoldProd({
          salesId: this.$wxuserUtil.getUserId(),
          custId: custId,
        })
        .then((Response) => {
          if (Response.success == true) {
            if (Response.data.length > 0) {
              for (let i = 0; i < Response.data.length; i++) {
                Response.data[i]["edit"] = false;
                Response.data[i]["height"] = "auto";
                // let type=Response.data[i].products1stType
                // switch(type){
                //   case '徕卡相机'  : that.tab[0].list.push(Response.data[i]);break
                //   case '徕卡镜头'  : that.tab[1].list.push(Response.data[i]);break
                //   case '运动光学及配件'  : that.tab[2].list.push(Response.data[i]);break
                // }
              }
              this.list = Response.data;
            }
          }
        });
    },
    changTab(index) {
      this.tabActive = index;
    },
    /**
     *
     *  购买产品详情
     *  @param {String}   custId   客户Id
     *  @param {String}   purchaseRecordId   产品购买ID
     *  @param {String}   salesId
     *
     */
    getDetailSoldProdCust() {
      this.$api
        .getDetailSoldProdCust({
          salesId: this.$wxuserUtil.getUserId(),
          custId: this.custId,
          purchaseRecordId: this.purchaseRecordId,
        })
        .then((Response) => {
          console.log("sssssssssssss", Response);
          if (Response.success) {
            let $data = Response.data[0];
            this.getProdQueryPrice($data.code);
            let $PL = [];
            $PL = this.pullList;
            $PL[0]["name"] = $data.code;
            $PL[0]["val"] = $data.code;
            $PL[1]["name"] = $data.serial;
            $PL[1]["val"] = $data.serial;
            $PL[2]["name"] = $data.products1stType;
            $PL[2]["val"] = $data.products1stType;
            $PL[3]["name"] = $data.products2ndType;
            $PL[3]["val"] = $data.products2ndType;
            $PL[4]["name"] = $data.productNameCH;
            $PL[4]["val"] = $data.productNameCH;
            $PL[5]["name"] = $data.productNameEN;
            $PL[5]["val"] = $data.productNameEN;
            $PL[6]["name"] = $data.amountAftTax;
            $PL[6]["val"] = $data.amountAftTax;
            $PL[7]["name"] = $data.amount;
            $PL[7]["val"] = $data.amount;
            $PL[8]["name"] = $data.couponType;
            $PL[8]["val"] = $data.couponTypeDval;
            $PL[9]["name"] = $data.couponNo;
            $PL[9]["val"] = $data.couponNo;
            $PL[10]["name"] = $data.deptName;
            $PL[10]["val"] = $data.deptId;
            $PL[11]["name"] = $data.userName;
            $PL[11]["val"] = $data.userId;
            $PL[12]["val"] = $data.buyDate;
            $PL[12]["name"] = $data.buyDate;
            $PL[14]["name"] = $data.reason;
            $PL[14]["val"] = $data.reason;
            if ($data.salesTicketUrl != null) {
              this.uploadCertificate = this.http + $data.salesTicketUrl;
            }
            $PL[16]["val"] = $data.U_SecondProduct === "1";
            this.pullList = $PL;
            // this.ratesCount();
          }
        });
    },
    /**
     *
     *
     *   产品一级分类
     *   @param {String}   salesId
     *
     */
    getProdQuery1st() {
      this.$api
        .getProdQuery1st({
          salesId: this.$wxuserUtil.getUserId(),
        })
        .then((Response) => {
          if (Response.success) {
            let data = Response.data;
            for (let i = 0; i < data.length; i++) {
              if (data[i]["name"]) {
                data[i]["value"] = data[i]["name"];
                data[i]["val"] = data[i]["name"];
              }
            }
            this.Products1stType = data;
          }
        });
    },
    /**
     *
     *   产品二级分类
     *   @param {String}   salesId
     *   @param {String}   prod1st   一级分类名称
     *
     */
    getProdQuery2st() {
      if (this.pullList[2]["name"] == "") {
        this.$title("请选择产品大类");
        return;
      }
      this.$api
        .getProdQuery2st({
          salesId: this.$wxuserUtil.getUserId(),
          prod1st: this.pullList[2]["name"],
        })
        .then((Response) => {
          if (Response.success) {
            let data = Response.data;
            for (let i = 0; i < data.length; i++) {
              if (data[i]["name"]) {
                data[i]["value"] = data[i]["name"];
                data[i]["val"] = data[i]["name"];
              }
            }
            this.Products2ndType = data;
          }
        });
    },
    /**
     *
     *  收起 打开
     *  @param {Bealoon}  val
     *  @param {Number}   index
     */
    packUp(index) {
      let $list = [];
      $list = this.list;
      if ($list[index]["edit"] == true) {
        $list[index]["edit"] = false;
        this.list = $list;
      } else if ($list[index]["edit"] == false) {
        $list[index]["edit"] = true;
        this.list = $list;
      }
    },
    /**
     *
     *  未税金额计算
     *
     **/
    ratesCount() {
      if (this.pullList[6]["name"]) {
        this.pullList[7]["name"] = (
          this.pullList[6]["name"] /
          (1 + this.rates)
        ).toFixed(2);
      }
    },
    authority(Bl) {
      this.showCC = Bl;
    },
    timeConfirm(val) {
      console.log("购买日期返回", val);
      if (val) {
        this.pullList[12]["name"] = this.$time(val);
        this.pullList[12]["val"] = this.$time(val);
      }
      this.timeShow = false;
    },
    timeCancel(val) {
      this.timeShow = false;
    },
    timeSelections() {
      this.timeShow = true;
    },
    /**
     * 查询消费券类型
     */
    queryCouponType() {
      this.$api
        .get("api/coupon/queryAllType", {
          salesId: this.$wxuserUtil.getUserId(),
        })
        .then((ret) => {
          if (ret.success) {
            this.CouponType = ret.data;
          }
        });
    },
  },
  mounted() {
    this.hasPRCreated = this.$wxuserUtil.hasFunAuthByRouteInst(
      this.$route,
      this.$funcKey.PRCreated
    );
    this.hasPRModified = this.$wxuserUtil.hasFunAuthByRouteInst(
      this.$route,
      this.$funcKey.PRModified
    );
    this.deptType = this.$wxuserUtil.getUserObj()["deptType"] || "";
    this.getQueryByTcode();
    this.getDealerlist();
    this.getProdQuery1st();
    this.queryCouponType();
  },
  created() {
    // this.$wxuserUtil.initWxSdk()
  },
};
</script>



<style lang="less" scoped>
.buyProduct-content {
  .van-uploader__preview {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    border: none;
    outline: none;
  }

  .van-image {
    position: relative;
    display: inline-block;
  }

  .van-uploader__preview-image {
    display: block;
    width: 50px;
    height: 50px;
    margin-left: -1rem;
    overflow: hidden;
  }

  .van-image__img {
    display: block;
    width: 100%;
    height: 100%;
  }

  .van-uploader__preview-delete {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
  }

  .van-uploader__preview-delete-icon {
    position: absolute;
    top: -2px;
    right: -2px;
    color: #fff;
    font-size: 16px;
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
  }

  .product-model {
    .van-popup {
      width: 9rem;
      height: 14.5rem;
      border-radius: 0.3rem;

      .model-height {
        height: 13.1rem;
        overflow-y: auto;
      }

      // 确定取消
      .confirm-cancel {
        width: 100%;
        height: 1.4rem;
        border-top: 1px solid #b3b8c3;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 0rem;

        .button-flex-color {
          width: 50%;
          height: 1.4rem;
          text-align: center;

          .button-flex-item {
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 1.3rem;
            font-size: 0.4rem;
            background: #222222;
            color: #fff;
          }

          .button-active {
            background: #e51c23;
            color: #fff;
          }
        }

        .flex-border-button {
          // border-right: 1px solid #a4abba;
        }
      }

      input {
        border: none;
        outline: none;
        width: 100%;
        background: #ffffff;
      }

      .product-title {
        height: 1.5rem;
        line-height: 1.5rem;
        text-align: center;
        font-weight: bold;
        color: #252424;
      }

      .basic-models-list {
        height: 95%;
        font-size: 0.35rem;
        // overflow-x: auto;
        width: 95%;
        margin: 0 auto;

        .basic-models-list-item,
        .basic-models-list-itemS {
          margin-left: 0.8rem;
          height: 1.2rem;
          -ms-flex-item-align: center;
          align-items: center;
          display: flex;
          flex-direction: row;
          // justify-content: space-between;
          position: relative;
        }

        .selectUp {
          border: 0;
          margin: 0;
          padding: 0;
          width: 100%;
          resize: none;
          display: block;
          color: #323233;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          background-color: transparent;

          .uparrow {
            position: absolute;
            right: 0.2rem;
            top: 50%;
            width: 0.3rem;
            height: 0.3rem;
            margin-top: -0.15rem;
          }

          input {
            border: none;
            outline: none;
          }

          textarea {
            border: none;
            outline: none;
            height: 0.8rem;
            width: 4rem;
          }
        }
      }

      .basic-models-list-item:after {
        content: "  ";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: #b3b8c3;
        /* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*/
        -webkit-transform: scaleY(0.15);
        transform: scaleY(0.15);
      }

      .van-cell {
        padding: 0rem;
      }

      .models-list-item-title {
        width: 5rem;
      }

      .region {
        width: 3rem;
        position: relative;
        height: 1.2rem;
        line-height: 1.2rem;
        -ms-flex-item-align: center;
        align-items: center;
        padding-left: 0.1rem;

        // border-right: 1px  solid  #b3b8c3;
        .uparrow {
          position: absolute;
          right: 0.5rem;
          top: 50%;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: -0.15rem;
        }
      }
    }
  }

  .product-model-min {
    .van-popup {
      width: 6rem;
      height: 2.8rem;
      border-radius: 0.5rem;

      .model-height {
        overflow-y: auto;
      }

      // 确定取消
      .confirm-cancel {
        width: 100%;
        height: 1.4rem;
        border-top: 2px solid #000000;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 0.1rem;

        .button-flex-color {
          width: 30%;
          height: 1.4rem;
          padding-top: 0.2rem;
          text-align: center;

          .button-flex-item {
            width: 100%;
            height: 60%;
            text-align: center;
            line-height: 0.8rem;
            font-size: 0.4rem;
            background: #222222;
            color: #fff;
          }

          .button-active {
            background: #e51c23;
            color: #fff;
            border-radius: 0.2rem;
          }
        }
      }

      .product-title {
        height: 1.5rem;
        line-height: 1.5rem;
        text-align: center;
        font-size: 0.4rem;
        color: #000000;
      }
    }
  }

  .newlyAddImg {
    width: 0.5rem;
    height: 0.5rem;
  }

  .product-list-content {
    .basic-information-flex {
      padding: 0.3rem 0.5rem;
      position: relative;
      overflow: hidden;
      transition: all 0.5s;
      -webkit-transition: all 0.5s;
      -o-transition: all 0.5s;
      -ms-transition: all 0.5s;
      .list-status {
        position: absolute;
        top: 0.1rem;
        right: 0.2rem;
        font-size: 12px;
        color: #333;
        text-align: center;
        font-weight: bold;
        a {
          display: block;
          margin-top: 1px;
          font-weight: normal;
          color: #fff;
          text-align: center;
          padding: 5px;
          background-color: red;
          border-radius: 5px;
        }
      }
    }

    .active {
      height: auto !important;
    }

    .activeno {
      height: 3.1rem !important;
    }
  }

  .product-list {
    margin: 0.3rem 0.5rem 0.3rem 0.5rem;
    // background: #F2F2F2;
    min-height: 1rem;

    .basic-information-flex {
      padding: 0.3rem 0.5rem;
      overflow: hidden;
      transition: all 0.5s;
      -webkit-transition: all 0.5s;
      -o-transition: all 0.5s;
      -ms-transition: all 0.5s;

      .basic-information-lists {
        li {
          display: flex;
          //    justify-content: space-between;
          -ms-flex-item-align: center;
          align-items: center;
          min-height: 0.8rem;
          line-height: 0.8rem;
        }

        .basic-information-lists-item {
          width: 2.5rem;
          color: #7e7e7e;
          font-size: 0.35rem;
        }

        .basic-information-lists-text {
          font-size: 0.35rem;
          color: #4d4d4d;
        }
      }
    }

    .product-list-content {
      background: #f2f2f2;
    }

    .packUp {
      padding: 0rem 0.3rem;
      background: #f2f2f2;
      margin-top: 0.05rem;
      margin-bottom: 0.3rem;
      height: 1rem;
      line-height: 1rem;
    }

    .arrow {
      width: 0.4rem;
      height: 0.4rem;
    }

    .product-list-header {
      height: 1rem;
      -ms-flex-item-align: center;
      align-items: center;
      padding: 0rem 0.3rem;
      flex-direction: row;
      justify-content: space-between;
      background: #f2f2f2;

      .product-name {
        color: #2a2a2a;
        font-size: 0.4rem;
        padding-left: 0.3rem;
      }
    }

    .camera,
    .redactImg {
      width: 0.4rem;
      height: 0.4rem;
    }
  }

  .buyProduct {
    // width:100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    -ms-flex-item-align: center;
    align-items: center;
    height: 1rem;
    padding: 0.3rem 0.5rem 0rem 0.5rem;
    border-top: 0.1rem solid rgb(244, 244, 244);

    .redactImg {
      width: 0.4rem;
      height: 0.4rem;
    }

    .basic-information-title {
      position: relative;
      color: #2a2a2a;
      font-size: 0.4rem;
      font-weight: 600;
    }

    .basic-information-title::after {
      content: "";
      width: 0.1rem;
      height: 0.35rem;
      position: absolute;
      left: -0.2rem;
      top: 0.12rem;
      background-color: #e10913;
    }
  }
}
.van-tabs__nav--card {
  border-bottom: none;
}
.second-product {
  width: 100%;
  text-align: right;
  margin-right: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/haveProduct.vue